import React from "react";
import FaqSection from "components/FaqSection";
import GuideSection from "components/GuideSection";
import Link from "next/link";
import SideBar from "./SideBar";
import { HeaderH2, HeaderH1, Text, NextButton, ImageBlock } from "components/TextBlocks";
import Image from "next/image";

function CreateNote(props) {
  const keyCss = {
    fontSize: "1rem",
    fontFamily: "menlo, consolas, monospace",
    border: "1px solid #DDDDDD",
    borderRadius: "5px",
    boxShadow: "0 4px 8px -1px rgba(201,204,208,0.90)",
    backgroundColor: "#FFF",
    paddingTop: "4px",
    paddingBottom: "4px",
    paddingLeft: "7px",
    paddingRight: "6px",
  };
  return (
    <>
      <HeaderH1>Add reminders</HeaderH1>
      <Text>
        Create your own scheadule of reminders for sites and note, one-time reminders or repeating
        ones.
      </Text>
      <ImageBlock
        mtLess
        src={"/guide/calendarview.png"}
        width={1028}
        height={998}
        quality={100}
        alt={"Calendar view"}
      />
      <HeaderH2 id="Toolbar">Reminders on sites</HeaderH2>
      <Text>
        To add a reminder to a site, first locate the site and open its modal. Inside the modal,
        click on the reminder button. This action will open a popover where you can select either a
        one-time reminder or a repeating one.
      </Text>
      <ImageBlock
        src={"/guide/site_reminder.png"}
        width={802}
        height={759}
        quality={100}
        alt={"Site reminder"}
      />
      <HeaderH2 id="bullet">Reminders on notes/to-do's</HeaderH2>
      <Text>
        Enter the edit mode for a note and click the bell icon in the text toolbar. From there, you
        can select either a one-time or repeating reminder. After making your choice, click 'save'.
      </Text>
      <ImageBlock
        src={"/guide/note_reminder.png"}
        width={642}
        height={540}
        quality={100}
        alt={"Note reminder"}
      />
      <NextButton
        cta={"Combine items"}
        textColor={"#565D65"}
        bg={"#EBECED"}
        page={"/guide/combine"}
      />
    </>
  );
}

CreateNote.Layout = SideBar;

export default CreateNote;
